import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle2, AlertCircle } from "lucide-react";
import api from "../lib/api";

export default function PaymentSuccess() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      if (attempts.current > 10) { setStatus("error"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch {}
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <main className="min-h-[70vh] flex items-center justify-center px-6 relative z-10" data-testid="payment-success-page">
      <div className="text-center max-w-md">
        {status === "checking" && (
          <>
            <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
            <p className="text-foreground/70 mt-6" data-testid="payment-checking">{t("payment.checking")}</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={48} strokeWidth={1.2} className="text-primary mx-auto" />
            <h1 className="font-serif-display text-4xl mt-6" data-testid="payment-success-title">{t("payment.success")}</h1>
            <p className="text-foreground/65 mt-3">{t("payment.successDesc")}</p>
            <Link to="/parcours" className="inline-block mt-8 px-7 py-3 rounded-full bg-primary text-primary-foreground text-sm font-medium hover:bg-[#16528A] transition-colors duration-200" data-testid="payment-back-btn">
              {t("payment.back")}
            </Link>
          </>
        )}
        {status === "error" && (
          <>
            <AlertCircle size={48} strokeWidth={1.2} className="text-destructive mx-auto" />
            <h1 className="font-serif-display text-3xl mt-6">{t("payment.error")}</h1>
            <Link to="/parcours" className="inline-block mt-8 text-primary underline underline-offset-4">{t("payment.back")}</Link>
          </>
        )}
      </div>
    </main>
  );
}
